// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vc-container[data-v-79f7708b]{--day-content-height:50px;--day-content-width:50px}", ""]);
// Exports
module.exports = exports;
